export default __webpack_public_path__ + "static/hero_left-84cdfe442eb3d406ce28693c6fad76f0.png";